import { openToast } from "store/slices/common/toast.slice";
import {
  addMaintenance,
  archiveMaintenance,
  deleteMaintenance,
  getAllMaintenance,
  getAllSettings,
  getDefaultPreferences,
  updateDefaultPreferences,
  updateMaintenance,
  updateSettings,
} from "store/services/settings";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const GetAllSettingsAction = createAsyncThunk(
  "settings/getSettings",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await getAllSettings(payload);
      if (response.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(response);
      }
      return rejectWithValue({ message: response?.message });
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const UpdateSettingsAction = createAsyncThunk(
  "settings/updateSettings",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    let { onSuccess, onError, ...rest } = payload;
    try {
      const response = await updateSettings(rest);
      if (response.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        if (onSuccess) onSuccess();
        return fulfillWithValue(response);
      }
      if (onError) onError();
      dispatch(openToast({ type: "error", message: response?.message }));
      return rejectWithValue({ message: response?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetDefaultPreferencesAction = createAsyncThunk(
  "settings/getDefaultPreferences",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await getDefaultPreferences(payload);
      if (response.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(response);
      }
      return rejectWithValue({ message: response?.message });
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const UpdateDefaultPreferencesAction = createAsyncThunk(
  "settings/updateDefaultPreferences",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    let { onSuccess, onError, ...rest } = payload;
    try {
      const response = await updateDefaultPreferences(rest);
      if (response.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        if (onSuccess) onSuccess();
        return fulfillWithValue(response);
      }
      if (onError) onError();
      dispatch(openToast({ type: "error", message: response?.message }));
      return rejectWithValue({ message: response?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const GetAllMaintenanceAction = createAsyncThunk(
  "settings/getAllMaintenance",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const response = await getAllMaintenance(payload);
      if (response.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(response);
      }
      return rejectWithValue({ message: response?.message });
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const UpdateMaintenanceAction = createAsyncThunk(
  "settings/updateMaintenance",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    let { onSuccess, onError, ...rest } = payload;
    try {
      const response = await updateMaintenance(rest);
      if (response.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        dispatch(GetAllMaintenanceAction(rest?.filter || {}));
        if (onSuccess) onSuccess();
        return fulfillWithValue(response);
      }
      if (onError) onError();
      dispatch(openToast({ type: "error", message: response?.message }));
      return rejectWithValue({ message: response?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const AddMaintenanceAction = createAsyncThunk(
  "settings/addMaintenance",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    let { onSuccess, onError, ...rest } = payload;
    try {
      const response = await addMaintenance(rest);
      if (response.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        dispatch(GetAllMaintenanceAction(rest?.filter || {}));
        if (onSuccess) onSuccess();
        return fulfillWithValue(response);
      }
      if (onError) onError();
      dispatch(openToast({ type: "error", message: response?.message }));
      return rejectWithValue({ message: response?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const DeleteMaintenanceAction = createAsyncThunk(
  "settings/deleteMaintenance",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    let { onSuccess, onError, ...rest } = payload;
    try {
      const response = await deleteMaintenance(rest);
      if (response.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        dispatch(GetAllMaintenanceAction(rest?.filter || {}));
        if (onSuccess) onSuccess();
        return fulfillWithValue(response);
      }
      if (onError) onError();
      dispatch(openToast({ type: "error", message: response?.message }));
      return rejectWithValue({ message: response?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

export const ArchiveMaintenanceAction = createAsyncThunk(
  "settings/archiveMaintenance",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    let { onSuccess, onError, ...rest } = payload;
    try {
      const response = await archiveMaintenance(rest);
      if (response.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        dispatch(GetAllMaintenanceAction(rest?.filter || {}));
        if (onSuccess) onSuccess();
        return fulfillWithValue(response);
      }
      if (onError) onError();
      dispatch(openToast({ type: "error", message: response?.message }));
      return rejectWithValue({ message: response?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);